import styled from '@emotion/styled';

// We apply padding to top of component in order to ensure that the container content is fully displayed
// (not hidden by sticky header) when navigating to an anchor ref.
export const SectionContainerRoot = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding-top: ${({ theme }) => theme.spacing(12)};

  &:first-of-type {
    padding-top: ${({ theme }) => theme.spacing(6)};
  }

  &:last-of-type {
    padding-bottom: ${({ theme }) => theme.spacing(6)};
  }
`;

export const SectionHeader = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spacing(2)};
  align-items: center;
  width: 100%;
`;

export const HeaderContent = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing(3)};
`;

export const SectionContent = styled.div`
  width: 100%;
`;
